import { Button } from '@frontend/ui'
import { Download } from 'lucide-react'
import { useExportConfig } from '../lib/export-context'
import { ExportButton } from './export-button'

export function GlobalExportButton() {
  const config = useExportConfig()

  if (!config) {
    return (
      <Button
        variant='ghost'
        disabled
        className='print:hidden'
        aria-label='Export (unavailable on this page)'
      >
        <Download className='mr-2 h-4 w-4' />
        Export
      </Button>
    )
  }

  return (
    <ExportButton
      sessionId={config.sessionId}
      sessionDate={config.sessionDate}
      sessionName={config.sessionName}
      sport={config.sport}
    />
  )
}
